import React, { useEffect, useState } from 'react';

import { compile, run } from '@mdx-js/mdx';
import * as runtime from 'react/jsx-runtime';
import remarkGfm from 'remark-gfm';

import { mdxComponents } from '../../helpers/mdx';

interface Props {
  className?: string;
  content: string;
}

const evalMDX = async (content) => {
  const __content = String(
    await compile(content, {
      outputFormat: 'function-body',
      development: false,
      remarkPlugins: [
        // @ts-expect-error
        remarkGfm
      ]
    })
  );
  const MDXContent = await run(__content, {
    ...runtime
    // jsxDEV: runtime?.['jsxDEV'] || runtime?.['jsx']
  });

  return MDXContent;
};

export const Preview = ({ content }: Props) => {
  const [error, setError] = useState<Error | null>(null);
  const [MDX, setMdx] = useState<null | {
    default: (props: {
      components?: { [key: string]: unknown };
    }) => JSX.Element;
  }>(null);

  useEffect(() => {
    (async () => {
      try {
        const MDXContent = await evalMDX(content);
        setMdx(MDXContent);
      } catch (e) {
        setError(e);
      }
    })();
  }, [content, setMdx, setError]);

  if (error) {
    return (
      <div>
        Error: {error.message}
        <pre>
          <code>{error.stack}</code>
        </pre>
      </div>
    );
  }

  return <>{MDX && <MDX.default components={mdxComponents} />}</>;
};
